import { useProgress } from '@bprogress/next';
import { Router } from 'next/router';
import { useEffect } from 'react';

// bprogress is configured with `shallowRouting` so it suppresses the top
// loader for any same-pathname navigation. That also hides it when a real
// page load happens with only query-string changes. Manually start the bar
// for those cases — bprogress's own routeChangeComplete listener will stop it.
export const useQueryChangeProgressBar = () => {
  const { start } = useProgress();

  useEffect(() => {
    const onRouteChangeStart = (
      url: string,
      { shallow }: { shallow: boolean }
    ) => {
      if (shallow) {
        return;
      }
      const target = new URL(url, window.location.href);
      const current = new URL(window.location.href);
      if (
        target.pathname === current.pathname &&
        target.search !== current.search
      ) {
        start();
      }
    };

    Router.events.on('routeChangeStart', onRouteChangeStart);
    return () => {
      Router.events.off('routeChangeStart', onRouteChangeStart);
    };
  }, [start]);
};
